module.exports = __webpack_public_path__ + "static/media/logo_login.e1f08d4d.png";